import { inch2cm } from "./insole-web-common/src/engine/parameters.js";
export const cutoutHeelPreset = {
    shape: "Ellipse",
    u: 0.82,
    v: 0.5,
    d1: inch2cm * 1.0,
    d2: inch2cm * 1.0,
    rotation: 0,
};
export const cutoutMPJ5Preset = {
    shape: "Ellipse",
    u: 0.119,
    v: 0.972,
    d1: inch2cm * 1.0,
    d2: inch2cm * 0.75,
    rotation: -30,
};
// Currently this is only used in the prescription
export const cutoutMPJ1Preset = {
    shape: "Ellipse",
    u: -0.125,
    v: -0.1,
    d1: inch2cm * 3.0,
    d2: inch2cm * 1.75,
    rotation: -10,
};
export const cutoutMetabase5Preset = {
    shape: "Ellipse",
    u: 0.369,
    v: 0.972,
    d1: inch2cm * 1.25,
    d2: inch2cm * 1.0,
    rotation: 0,
};
export const cutoutPresets = {
    Heel: cutoutHeelPreset,
    MPJ5: cutoutMPJ5Preset,
    Metabase5: cutoutMetabase5Preset,
};
export const dwHeelPreset = {
    shape: "Ellipse",
    u: 0.82,
    v: 0.5,
    h: -0.25,
    d1: inch2cm * 1.0,
    d2: inch2cm * 1.0,
    rotation: 0,
    s1: 0.5,
    s2: 0.5,
};
export const dwMetabase5Preset = {
    shape: "Ellipse",
    u: 0.284,
    v: 0.995,
    h: -0.3,
    d1: inch2cm * 1.0,
    d2: inch2cm * 1.0,
    rotation: 0,
    s1: 0.5,
    s2: 0.5,
};
export const dwNavicularPreset = {
    shape: "Ellipse",
    u: 0.493,
    v: 0.0,
    h: -0.3,
    d1: inch2cm * 2.25,
    d2: inch2cm * 1.75,
    rotation: 0,
    s1: 0.5,
    s2: 0.5,
};
export const dwPresets = {
    Heel: dwHeelPreset,
    Metabase5: dwMetabase5Preset,
    Navicular: dwNavicularPreset,
};
export function mapRangeLinear(fromStart, fromEnd, toStart, toEnd, fromValue) {
    return toStart + ((toEnd - toStart) * (fromValue - fromStart)) / (fromEnd - fromStart);
}
export function epsilonCompare(a, b) {
    return Math.abs(a - b) < 0.0001;
}
export function rbwConvertHPSmoothing(hpSmoothing) {
    return mapRangeLinear(0.0, 10.0, 1.0, 10.0, hpSmoothing);
}
export function rbwInverseConvertHPSmoothing(smoothing) {
    return mapRangeLinear(1.0, 10.0, 0.0, 10.0, smoothing);
}
export const rbwStandardPreset = {
    regionBasedWidthProximalPoint: -2.0,
    regionBasedWidthDistalPoint: 2.0,
    regionBasedWidthWidth: 0.0,
    regionBasedWidthSmoothing: rbwConvertHPSmoothing(0.0),
    regionBasedWidthLockDistal: false,
    regionBasedWidthMedialSideEnabled: true,
    regionBasedWidthLateralSideEnabled: true,
};
export const rbwHourglassPreset = {
    regionBasedWidthProximalPoint: -3.0,
    regionBasedWidthDistalPoint: 7.0,
    regionBasedWidthWidth: -0.3,
    regionBasedWidthSmoothing: rbwConvertHPSmoothing(1.0),
    regionBasedWidthLockDistal: true,
    regionBasedWidthMedialSideEnabled: true,
    regionBasedWidthLateralSideEnabled: true,
};
export const rbwMedialDeformityPreset = {
    regionBasedWidthProximalPoint: -7.0,
    regionBasedWidthDistalPoint: 7.0,
    regionBasedWidthWidth: 0.5,
    regionBasedWidthSmoothing: rbwConvertHPSmoothing(1.0),
    regionBasedWidthLockDistal: true,
    regionBasedWidthMedialSideEnabled: true,
    regionBasedWidthLateralSideEnabled: false,
};
export const rbwLateralDeformityPreset = {
    regionBasedWidthProximalPoint: -7.0,
    regionBasedWidthDistalPoint: 7.0,
    regionBasedWidthWidth: 0.5,
    regionBasedWidthSmoothing: rbwConvertHPSmoothing(1.0),
    regionBasedWidthLockDistal: true,
    regionBasedWidthMedialSideEnabled: false,
    regionBasedWidthLateralSideEnabled: true,
};
export const rbwPresets = {
    Standard: rbwStandardPreset,
    HourGlass: rbwHourglassPreset,
    MedialDeformity: rbwMedialDeformityPreset,
    LateralDeformity: rbwLateralDeformityPreset,
    Specify: null,
};
//# sourceMappingURL=tool-presets.js.map